(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nm-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nmStockInit) return;
    window.__nmStockInit = true;

    var TZ = 'Asia/Kuala_Lumpur';

    function nowInTZ() {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: +p.hour };
    }
    function iso(d) { return d.toISOString().slice(0, 10); }

    function estimate(cfg) {
      function working(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && cfg.holidays.indexOf(iso(d)) === -1; }
      function addWorking(d, n) { var r = new Date(d.getTime()); while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); if (working(r)) n--; } return r; }
      var now = nowInTZ();
      var sameDay = working(now.date) && now.hour < cfg.cutoff;
      var tDay = sameDay ? now.date : addWorking(now.date, 1);   // T-day
      var d = addWorking(tDay, cfg.processing + cfg.shipping);
      return {
        date: d.toLocaleDateString('en-MY', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }),
        verb: sameDay ? 'Order today' : 'Order now'
      };
    }

    function readCfg(root) {
      var num = function (k, def) { var n = parseInt(root.getAttribute(k), 10); return isNaN(n) ? def : n; };
      return {
        processing: num('data-processing', 3),
        shipping: num('data-shipping', 3),
        cutoff: num('data-cutoff', 12),
        low: num('data-low', 10),
        region: root.getAttribute('data-region') || '',
        holidays: (root.getAttribute('data-holidays') || '').match(/\d{4}-\d{2}-\d{2}/g) || []
      };
    }

    function selectedVariantId(root) {
      var scope = root.closest('.shopify-section') || document;
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      return (input && input.value) || new URLSearchParams(location.search).get('variant');
    }

    function render() {
      document.querySelectorAll('[data-nm-stock]').forEach(function (root) {
        var dataEl = root.querySelector('[data-nm-stock-data]');
        if (!dataEl) return;
        var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
        var cfg = readCfg(root);
        var v = data.variants[selectedVariantId(root)] || data.variants[String(data.current)];
        var est = estimate(cfg);
        var when = '<strong>' + est.date + '</strong>' + (cfg.region ? ' <span class="nm-stock__note">(' + cfg.region + ')</span>' : '');
        var text = root.querySelector('.nm-stock__text');
        root.classList.remove('nm-stock--low', 'nm-stock--out');

        if (!v || !v.available) {
          root.classList.add('nm-stock--out');
          text.innerHTML = 'Out of stock';
        } else if (v.tracked && v.qty <= 0 && v.policy === 'continue') {
          text.innerHTML = 'Pre-order: ships as soon as we restock';
        } else if (v.tracked && v.qty <= cfg.low) {
          root.classList.add('nm-stock--low');
          text.innerHTML = 'Only ' + v.qty + ' left! ' + est.verb + ' to receive it by ' + when;
        } else {
          text.innerHTML = 'In stock. ' + est.verb + ' to receive it by ' + when;
        }
        root.setAttribute('data-nm-rendered', '1');
      });
    }

    function soon() { setTimeout(render, 60); setTimeout(render, 500); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
    document.addEventListener('change', soon);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.shopify-section')) soon(); });
    document.addEventListener('variant:update', soon);
    document.addEventListener('shopify:block:select', soon);
    document.addEventListener('shopify:section:load', soon);
    window.addEventListener('popstate', soon);
    // Re-fill if the theme re-renders the product details after a variant switch
    new MutationObserver(function () {
      if (document.querySelector('[data-nm-stock]:not([data-nm-rendered])')) render();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
